import transformInaccessibleFilters from "search-filter/logic/transformInaccessibleFilters";
import createSearch from "views/logic/slices/createSearch";
const transformInaccessibleFiltersInQueries = (queries, userPermissions) => queries.map((query) => {
  const updatedFilters = transformInaccessibleFilters(query.filters, userPermissions);
  return query.toBuilder().filters(updatedFilters.toList()).build();
});
const transformInaccessibleFiltersInSearch = async (view, userPermissions) => {
  const updatedQueries = transformInaccessibleFiltersInQueries(view.search.queries, userPermissions);
  const newSearchWithNewId = await createSearch(view.search.toBuilder().queries(updatedQueries.toSet()).build());
  return view.toBuilder().search(newSearchWithNewId).build();
};
export default transformInaccessibleFiltersInSearch;
